import { useFavouriteDefinitions, useLoadFavouriteDefinitionEffect } from 'app/area/favourite/hooks';
import { FiltersContainer } from 'app/area/filters/filters';
import * as React from 'react';

interface BowtieFiltersFavouriteProps {
  favouriteId: number;
  locale: string;
}

export function BowtieFiltersFavourite({
  favouriteId, locale
}: BowtieFiltersFavouriteProps) {
  
  const {
    definition,
    workingDefinition,
    updateDefinition
  } = useFavouriteDefinitions();

  useLoadFavouriteDefinitionEffect(favouriteId, true);

  return (
    <FiltersContainer
      definition={definition}
      workingDefinition={workingDefinition}
      updateDefinition={updateDefinition}
      locale={locale} />
  );
}
